module.exports = __webpack_public_path__ + "static/img/h20.1036cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h20.jpg
// module id = bgTZ
// module chunks = 0